import { createSlice } from "@reduxjs/toolkit";
import addEditPackage from "@custom/rtk-apis/billing/addBilling";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const addEditPackageSlice = createSlice({
  name: "addEditPackageSlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addEditPackage.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addEditPackage.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(addEditPackage.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default addEditPackageSlice.reducer;
export const { closeModal } = addEditPackageSlice.actions;
